import { useHistory } from "react-router-dom";

export const withHistory = (WrappedComponent: React.ComponentType<any>) => (props: any) => {
    const history = useHistory();

    return <WrappedComponent {...props} history={history} />;
};
